import { Box } from '@mui/material';
import type { GridRowSelectionModel } from '@mui/x-data-grid-pro';
import { useMemo, type Dispatch, type SetStateAction } from 'react';
import { useTranslation } from 'react-i18next';
import { GridCheckbox } from '~/components/GridCheckbox';
import { SelectableGridItem } from '~/components/cards/styles';
import { ContentCard, type ContentCardProps } from './ContentCard';
import { ContentFolderCard, type ContentFolderCardProps } from './ContentFolderCard';

interface ContentGridRowProps {
  item: ContentFolderCardProps['contentFolder'] | ContentCardProps['item'];
  onCheck: Dispatch<SetStateAction<GridRowSelectionModel>>;
  selectedIds: GridRowSelectionModel;
}

export const ContentGridRow = ({ item, onCheck, selectedIds }: ContentGridRowProps) => {
  const { t } = useTranslation();
  const selectionId = useMemo(() => `${item.__typename}-${item.id}`, [item]);
  const selected = selectedIds.includes(selectionId);

  return (
    <SelectableGridItem item xs={12} sm={6} md={3} lg={2} key={item.id} selected={selected}>
      {item.__typename === 'ContentFolder' ? (
        <ContentFolderCard contentFolder={item} />
      ) : (
        <Box position={'relative'}>
          <GridCheckbox
            checked={selected}
            inputProps={{ 'aria-label': t('common.actions.select_item', { name: item.name }) }}
            onChange={(event) => {
              if (event.target.checked) {
                return onCheck([...selectedIds, selectionId]);
              }
              onCheck(selectedIds.filter((x) => x !== `${item.__typename}-${item.id}`));
            }}
          />
          <ContentCard item={item} selected={selected} />
        </Box>
      )}
    </SelectableGridItem>
  );
};
